// extracted by mini-css-extract-plugin
export default {"cls1":"VeloErrorCard-Message_cls1__Va6+X","cls2":"VeloErrorCard-Message_cls2__dGFD2 VeloErrorCard-Message_cls1__Va6+X"};